// 빌드: ./fe-build.sh youthcrew
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import swal from 'sweetalert';
import Editor from "./components/common/editor.vue";
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import Share from './components/common/share.js';
import mobile from 'is-mobile';
import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";
import SwalAlert from "./components/common/swalAlert.vue";
import Validator from "./components/common/validation";
import DropImgAlt from "./components/common/dragImgAlt.vue";
import DropImgOne from "./components/common/dragImgFileOne.vue";
import DropVdThumOne from "./components/common/dragVdThumFileOne.vue";
import DropVideoChoiceThum from "./components/common/dragVideoChoiceThumFile.vue";
import DFile from "./components/common/dfile1.vue";
import KProgress from 'k-progress';
import {result} from "lodash/object";

Vue.use(VueFileAgent);
Vue.use(mobile);

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component('editor', Editor);
Vue.component('dropimg2', DropImg);
Vue.component('dropimg', DropImgAlt);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('dropimgone', DropImgOne);
Vue.component('dropvdthumone', DropVdThumOne);
Vue.component('dropvideochoicethum', DropVideoChoiceThum);
Vue.component('dfile', DFile);
Vue.component('k-progress', KProgress);

Vue.prototype.$http = Axios;
Vue.prototype.$pager = Pager;
Vue.prototype.$common = Common;

const VOICE_SUGGEST_STATE_KEY = 'voiceSuggestListState';
const VOICE_SUGGEST_BACK_INTENT_KEY = 'voiceSuggestBackIntent';
const POLICY_NOTICE_STATE_KEY = 'policyNoticeListState';
const POLICY_NOTICE_BACK_INTENT_KEY = 'policyNoticeBackIntent';
const POLICY_CONTEST_STATE_KEY = 'policyContestListState';
const POLICY_CONTEST_BACK_INTENT_KEY = 'policyContestBackIntent';
const POLICY_EVENT_STATE_KEY = 'policyEventListState';
const POLICY_EVENT_BACK_INTENT_KEY = 'policyEventBackIntent';

// 크루 콘텐츠/영상 목록 세션 스토리지 키
const CREW_CONTENTS_STATE_KEY = 'crewContentsListState';
const CREW_CONTENTS_BACK_INTENT_KEY = 'crewContentsBackIntent';
const CREW_MOVIE_STATE_KEY = 'crewMovieListState';
const CREW_MOVIE_BACK_INTENT_KEY = 'crewMovieBackIntent';
const CREW_STATE_TTL = 30 * 60 * 1000; // 30분

new Vue({
  el: '#youthcrew',
  data: function () {
    return {
      mainName: '청소년홍보단 몽땅크루',
      isMobile: false,
      isShare: false,
      isEditMode: false, // 수정 모드 플래그
      isCrewInfoLoaded: false, // 크루원 정보 자동 설정 플래그
      isLoadingCrewInfo: false, // 크루원 정보 로드 중 플래그 (watch 호출 방지용)
      fpt: '',
      listBanner: [],
      currentUsrKey: '', // 현재 로그인한 사용자 Key 추가
      isMobileStyle: {
        'width': '100%',
        'height': 'auto'
      },
      isMobileStyles: {
        'height': 'auto'
      },

      crewAiList: [],
      pageImgList: [],

      searchStr: [ "", ""],

      crewListModel:{
        list : [],
        imgList: [],
        affList: [],
      },

      viewYnModel: {
        areaGuid: '',
        affiliation: '',
        searchKeyword: ''
      },

      searchModel:
        {
          searchKword: ''
        },



      applyCrewModel: {
        areaGuid: '',
        facUid: '',
        cntrName: '',
        area: [],
        facility: {},
        facilityList: []
      },

      insertContentsModel: {
        brdCtg: '',
        areaGuid: '',
        facUid: '',
        cntrName: '',
        title: '',
        keyword: '',
        contents: '',
        linkUrl: '',
        area: [],
        affValues: [],
        affList: [],
        facility: {},
        facilityList: []
      },
      insertReport: {
        reportValue: '',
        reportEtcValue: ''
      },

      isCrew: false,
      isReady: false,
      isCrewChangeMode: false,
      loginArea: '',
      loginCntrName: '',

      viewModel:{
        list:[],
        detail:[],
        totalCount:0,
        checkedValues:[],
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0);"
        },
        showMore:true,
        showMore1:true,
        showMore2:true,
        zf:1,
        zt:1,
        boardPager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 5,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          class: 'paging_blue',
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.boardPager.etc;
            if (_etc == 'selectNoticeList') {
              this.model.fnGetPolicyNoticeList(n);
            }
          }
        },
        lineList: [], // 계열 코드 목록
        fileEtcList: [],
        fileImgList: [],
        fileVdList: [],
        fileThumList: [],
        fileVdThumList: [], // 영상 업로드 시, 자동 생성된 썸네일 목록
        fileUserThumList: [],

        totalReplyCount: 1,
        replyList: [],
        replyDepthZero: [],
        replyDepthOne: [],

        // like/report 상태 및 리스트
        isLike: false,
        isReport: false,

        isReply: false,
        isReplyUpt: false,
        isReReply: false,
        isReReplyUpt: false,
        currReplyUidKey: '',

        reportList: [],
        reportCodeList: [],
        areaList:
          [
            {
              "cmm_sys_cd": "동북권",
              "cmm_sys_titl": "동북권"
            },
            {
              "cmm_sys_cd": "동남권",
              "cmm_sys_titl": "동남권"
            },
            {
              "cmm_sys_cd": "서북권",
              "cmm_sys_titl": "서북권"
            },
            {
              "cmm_sys_cd": "서남권",
              "cmm_sys_titl": "서남권"
            }
          ],
        affList: [],
      },
      insertReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      insertReReplyModel: {
        brdUidKey: '',
        replyContent: ''
      },
      updateReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      updateReReplyModel: {
        brdUidKey: '',
        replyUidKey: '',
        replyContent: ''
      },
      replyModel: {
        replyList: [],
        rereplyList: [],
        replyName: '',
        userKey: '',
        modifyTarget: '',
        modifyContents: '',
        replyPassword: '',
        replyContents: '',
        replyStarCnt: '',
        reReplyTarget: '',
        reReplyContents: ''
      },
    }
  },
  created: function () {
    this.isMobile = mobile();
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$; // <template> 에서 $ 사용
    }
  },
  mounted: function ()
  {
    try {
      this.$nextTick(function () {
        pageLoad(this);
      });
    } catch (e) {
      console.log(e);
    }
  },
  filters: {
    currency: function (value) {
      let num = new Number(value);
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
    }
  },
  computed: {
    canEdit: function() {
      let authorUsrKey = this.viewModel.detail ? this.viewModel.detail.usrKey : null;
      return this.currentUsrKey && this.currentUsrKey !== '' && this.currentUsrKey === authorUsrKey;
    }
  },
  watch: {
    'insertContentsModel.area': {
      handler: function(newVal, oldVal) {
        // 수정 모드가 아닐 때, 그리고 크루원 정보 로드 중이 아닐 때만 권역 변경 시 센터 목록 로드
        // 수정 모드에서는 fnLoadContentsForEdit에서 처리
        // 크루원 정보 로드 중에는 fnLoadMyCrewInfo에서 직접 처리
        if (newVal && newVal.cmm_sys_cd && !this.isEditMode && !this.isLoadingCrewInfo) {
          console.log('권역 변경 감지 - 센터 목록 로드:', newVal.cmm_sys_titl);
          this.fnGetFacilityList();
        }
      },
      deep: true
    }
  },
  methods: {
    clickFunc: function (event) {
      event.target.focus();
    },
    fnGoToYouthCrew(path) {
      if (path == 'movie') {
        location.href = '/customer/crew/movie';
      } else if (path == 'content') {
        location.href = '/customer/crew/content';
      }else if (path == 'introduce') {
        location.href = '/customer/crew/introduce';
      }

    },
    fnSetContents()
    {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "컨텐츠 등록은 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      let vm = this;

      let isContentsMode = false; // 동아리 콘텐츠 모드 여부
      let memberUsrKeyList = [];
      let param = {};

      // 수정 모드인지 확인
      let paramUid = $("#paramUid").val();
      let isUpdateMode = paramUid && paramUid !== '';

      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();

      // 수정 모드인 경우 uidKey 추가
      if (isUpdateMode) {
        param.uidKey = paramUid;
      }

      param.brdCtg = vm.insertContentsModel.brdCtg;
      param.areaGuid = vm.insertContentsModel.area ? vm.insertContentsModel.area.cmm_sys_cd : vm.insertContentsModel.areaGuid;
      param.facUid = (vm.insertContentsModel.facility && vm.insertContentsModel.facility.uid) || vm.insertContentsModel.facUid || '';
      param.cntrName = vm.insertContentsModel.cntrName || '';
      param.title = vm.insertContentsModel.title || '';
      param.keyword = vm.insertContentsModel.keyword || '';
      param.contents = vm.insertContentsModel.contents || '';
      param.affValues = vm.insertContentsModel.affValues || [];
      param.linkUrl = vm.insertContentsModel.linkUrl || '';
      param.pick_vd_thum_uid = vm.$refs.dropvideochoicethum ? vm.$refs.dropvideochoicethum.pick_thum_uid : null; // 사용자가 선택한 썸네일 이미지 uid

      if (vm.insertContentsModel.brdCtg == null || vm.insertContentsModel.brdCtg == "") {
        swal("등록할 콘텐츠 유형을 선택 해주세요.").then(function () {
          $('#kind1').focus();
        });
        return false;
      }

      if (vm.insertContentsModel.area.length == 0) {
        swal("권역을 선택 해주세요.").then(function () {
          $('#area').focus();
        });
        return false;
      }

      if (!param.facUid || param.facUid == "") {
        swal("소속 센터를 선택해 주세요.").then(function () {
          $('#facility').focus();
        });
        return false;
      }

      if (vm.insertContentsModel.cntrName == null || vm.insertContentsModel.cntrName == "") {
        swal("소속 센터명을 입력해 주세요.").then(function () {
          $('#cntrName').focus();
        });
        return false;
      }

      if (vm.insertContentsModel.title == null || vm.insertContentsModel.title == "") {
        swal("제목을 입력해주세요.").then(function () {
          $('#title').focus();
        });
        return false;
      }

      // [임시 비활성화] 계열 필수 입력 validation - 추후 복원 예정
      // if (vm.insertContentsModel.affValues.length < 1) {
      //   swal('계열을 선택해 주세요.').then(function () {
      //     $("html, body").animate({scrollTop: $("#affValues").offset().top-200}, 100);
      //   });
      //   return false;
      // }

      // 동영상 업로드 validation (brdCtg가 'movie'일 때)
      if (vm.insertContentsModel.brdCtg === 'movie') {
        if (!vm.$refs.dropvideochoicethum || vm.$refs.dropvideochoicethum.cnt === 0) {
          swal('동영상을 업로드해 주세요.').then(function () {
            $("html, body").animate({scrollTop: $(".attach-wrap").offset().top-200}, 100);
          });
          return false;
        }
        // 동영상 업로드가 진행 중인지 확인
        if (vm.$refs.dropvideochoicethum && vm.$refs.dropvideochoicethum.videoUploadRes &&
            vm.$refs.dropvideochoicethum.videoUploadRes.resValue === 'ready') {
          swal('동영상 업로드가 진행 중입니다. 업로드 완료 후 다시 시도해 주세요.').then(function () {
            $("html, body").animate({scrollTop: $(".attach-wrap").offset().top-200}, 100);
          });
          return false;
        }
        // 동영상 업로드가 실패한 경우 확인
        if (vm.$refs.dropvideochoicethum && vm.$refs.dropvideochoicethum.videoUploadRes &&
            vm.$refs.dropvideochoicethum.videoUploadRes.resValue === 'fail') {
          swal('동영상 업로드에 실패했습니다. 동영상을 다시 업로드해 주세요.').then(function () {
            $("html, body").animate({scrollTop: $(".attach-wrap").offset().top-200}, 100);
          });
          return false;
        }
      }

      // 대표이미지 업로드 validation (brdCtg가 'contents'일 때)
      if (vm.insertContentsModel.brdCtg === 'contents') {
        if (!vm.$refs.dfile || vm.$refs.dfile.cnt === 0) {
          swal('대표이미지를 업로드해 주세요.').then(function () {
            $("html, body").animate({scrollTop: $(".attach-wrap").offset().top-200}, 100);
          });
          return false;
        }
      }

      // 수정/등록 API 분기
      let apiUrl = isUpdateMode ? "/customer/youthcrew/updateContents" : "/customer/youthcrew/insertContents";
      let successMsg = isUpdateMode ? "수정되었습니다" : "등록되었습니다";

      console.log('API 호출:', apiUrl);
      console.log('전송 데이터 (param):', param);
      console.log('전송 데이터 (wrapped):', {youthCrewVO: param});

      Axios.post(apiUrl, {youthCrewVO: param}).then(function (response) {
        if (response.data.succCnt > 0)
        {
          swal(successMsg).then(result => {
            if (vm.insertContentsModel.brdCtg == 'movie')
            {
              location.href = '/customer/crew/detailMovie?paramUid='+(isUpdateMode ? paramUid : response.data.youthCrewVO.uidKey);
            }
            else
            {
              location.href = '/customer/crew/detail?paramUid='+(isUpdateMode ? paramUid : response.data.youthCrewVO.uidKey);
            }
          });
          return false;
        } else if (response.data.succCnt == -1000) {
          swal({
            title: '등록 실패',
            text: '크루 권한이 없어 작성 할 수 없습니다.',
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            // icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false,
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true,
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnAddSubHbCntnt: function (cd) {
      let vm = this;
      if (vm.insertContentsModel.affValues.includes(cd)) {
        vm.insertContentsModel.affValues = vm.insertContentsModel.affValues.filter(e => e !== cd);
      } else {
        if (vm.insertContentsModel.affValues.length >= 3) {
          swal("계열은 최대 3개까지 선택 가능합니다");

        } else {
          vm.insertContentsModel.affValues.push(cd);
        }
      }
    },
    fnGetMovieDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.uidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/youthcrew/movieDetail", {youthCrewVO: param}).then(function (response) {
        vm.viewModel.detail = response.data.youthCrewVO;

        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetContentsDetail: function (updateFlag) {
      let vm = this;
      let param = {};
      param.uidKey = $("#paramUid").val();
      param.updateFlag = updateFlag ? updateFlag : null;

      Axios.post("/customer/youthcrew/detail", {youthCrewVO: param}).then(function (response) {
        vm.viewModel.detail = response.data.youthCrewVO;

        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnLoadContentsForEdit: function () { // 수정용 데이터 로드
      let vm = this;
      let paramUid = $("#paramUid").val();

      if (!paramUid) return;

      // 수정 모드 플래그 설정 (watch가 실행되지 않도록)
      vm.isEditMode = true;

      console.log('수정 모드: 데이터 로딩 시작', paramUid);

      let param = {};
      param.uidKey = paramUid;

      Axios.post("/customer/youthcrew/detail", {youthCrewVO: param}).then(function (response) {
        let detail = response.data.youthCrewVO;

        console.log('로드된 데이터:', detail);

        // 기본 정보 세팅
        vm.insertContentsModel.brdCtg = detail.brdCtg;
        vm.insertContentsModel.title = detail.title;
        vm.insertContentsModel.keyword = detail.keyword;
        vm.insertContentsModel.contents = detail.contents;
        vm.insertContentsModel.linkUrl = detail.linkUrl;

        // 계열 코드 세팅 (서버에서 | 로 구분된 문자열로 옴)
        if (detail.affCd) {
          vm.insertContentsModel.affValues = detail.affCd.split('|');
          console.log('계열 코드:', vm.insertContentsModel.affValues);
        }

        // 권역 세팅 후 센터 정보 순차적으로 로드
        if (detail.areaGuid) {
          // 권역 코드로 찾기 (cmm_sys_cd 또는 cmm_sys_titl로 매칭)
          vm.insertContentsModel.area = vm.viewModel.areaList.find(a =>
            a.cmm_sys_cd === detail.areaGuid || a.cmm_sys_titl === detail.areaGuid
          ) || {};

          // 권역을 찾지 못한 경우 직접 세팅
          if (!vm.insertContentsModel.area.cmm_sys_cd) {
            vm.insertContentsModel.area = {
              cmm_sys_cd: detail.areaGuid,
              cmm_sys_titl: detail.areaGuid
            };
          }

          console.log('권역 세팅:', vm.insertContentsModel.area);

          // 센터 정보 및 권역 정보 저장
          vm.insertContentsModel.areaGuid = detail.areaGuid;
          vm.insertContentsModel.facUid = detail.facUid || '';
          vm.insertContentsModel.cntrName = detail.cntrName || '';

          // 권역별 센터 목록 로드
          console.log('센터 목록 로드 시작 - 권역:', vm.insertContentsModel.area);
          vm.fnGetFacilityList().then(() => {
            console.log('센터 목록 로드 완료:', vm.insertContentsModel.facilityList.length, '개');

            // facUid가 있으면 센터 선택
            if (detail.facUid) {
              vm.insertContentsModel.facility = vm.insertContentsModel.facilityList.find(f => f.uid === detail.facUid) || {};
              if (vm.insertContentsModel.facility.centerName) {
                vm.insertContentsModel.cntrName = vm.insertContentsModel.facility.centerName;
              }
              console.log('센터 세팅 (facUid로 찾기):', vm.insertContentsModel.facility);
            }

            // 센터를 찾지 못했지만 cntrName이 있으면 cntrName으로 재시도
            if (!vm.insertContentsModel.facility.uid && detail.cntrName) {
              vm.insertContentsModel.facility = vm.insertContentsModel.facilityList.find(f =>
                f.centerName === detail.cntrName ||
                f.centerName.includes(detail.cntrName) ||
                detail.cntrName.includes(f.centerName)
              ) || {};
              if (vm.insertContentsModel.facility.centerName) {
                vm.insertContentsModel.cntrName = vm.insertContentsModel.facility.centerName;
              }
              console.log('센터 세팅 (cntrName으로 찾기):', vm.insertContentsModel.facility);
            }

            // 여전히 센터를 찾지 못한 경우 cntrName만이라도 세팅
            if (!vm.insertContentsModel.facility.uid && detail.cntrName) {
              vm.insertContentsModel.facility = {
                uid: detail.facUid || '',
                centerName: detail.cntrName
              };
              vm.insertContentsModel.cntrName = detail.cntrName;
              console.log('센터를 목록에서 찾지 못함. 직접 세팅:', vm.insertContentsModel.facility);
            }

            // 수정 모드 플래그 유지 (라디오 버튼 비활성화 상태 유지)
            console.log('센터 정보 로드 완료 - 수정 모드 유지:', vm.isEditMode);
          }).catch(function(err) {
            console.log('센터 목록 로드 실패:', err);
            // 실패해도 기본 정보는 세팅
            if (detail.cntrName) {
              vm.insertContentsModel.facility = {
                uid: detail.facUid || '',
                centerName: detail.cntrName
              };
              vm.insertContentsModel.cntrName = detail.cntrName;
            }
            // 수정 모드 플래그 유지 (라디오 버튼 비활성화 상태 유지)
            console.log('센터 정보 로드 실패 - 수정 모드 유지:', vm.isEditMode);
          });
        }

        // 파일 목록 세팅
        vm.viewModel.fileEtcList = response.data.fileEtcList || [];
        vm.viewModel.fileImgList = response.data.fileImgList || [];
        vm.viewModel.fileVdList = response.data.fileVdList || [];
        vm.viewModel.fileThumList = response.data.fileThumList || [];
        vm.viewModel.fileVdThumList = response.data.thumFileList || []; // 다중 썸네일 목록
        vm.viewModel.fileUserThumList = response.data.fileUserThumList || [];

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });

        console.log('수정 모드 데이터 로드 완료');
      }).catch(function (ex) {
        console.log('수정 데이터 로드 실패:', ex);
      });
    },
    fnGetReplyList: function (pageNumber) {
      let vm = this;
      //vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      //param.pageNo    = vm.viewModel.pager.pageNo;
      //param.pageSize  = vm.viewModel.pager.rowSize;

      Axios.post("/customer/youthcrew/selectReplyList", {youthCrewReplyVO: param}).then(function (response) {
        vm.viewModel.totalReplyCount = response.data.depthZeroList.length;
        vm.viewModel.replyDepthZero = response.data.depthZeroList;
        vm.viewModel.replyDepthOne = response.data.depthOneList;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnSetCode: function (_code) { // 코드 조회
      let vm = this;
      console.log(_code);

      return Axios.post("/api/expinfo/code", {searchCode: _code}).then(function (response) {
        vm.insertContentsModel.affList = response.data.expinfoCodeList;
        console.log('계열 목록 로드 완료:', vm.insertContentsModel.affList.length, '개');
        return response;
      }).catch(function (ex) {
        console.log('계열 목록 로드 실패:', ex);
        throw ex;
      });
    },
    // 크루원 정보 조회하여 권역/센터 자동 설정
    fnLoadMyCrewInfo: function () {
      let vm = this;
      let _userKey = $("#usrKey").val();

      // 로그인하지 않은 경우 스킵
      if (!_userKey || _userKey === '') {
        console.log('로그인되지 않음 - 크루원 정보 조회 스킵');
        return Promise.resolve();
      }

      // 크루원 정보 로드 시작 전 플래그 설정 (watch에서 중복 호출 방지)
      vm.isLoadingCrewInfo = true;

      return Axios.post("/customer/youthcrew/myCrewInfo", {}).then(function (response) {
        if (response.data.result === 1 && response.data.youthCrewVO) {
          let crewInfo = response.data.youthCrewVO;
          console.log('크루원 정보 조회 성공:', crewInfo);

          // 승인된(approve) 크루원만 자동 설정
          if (crewInfo.arpv === 'approve') {
            // 센터 정보 저장 (fnGetFacilityList 호출 후 자동 선택 위함)
            vm.insertContentsModel.facUid = crewInfo.facUid || '';
            vm.insertContentsModel.cntrName = crewInfo.cntrName || '';

            // 권역 자동 설정
            if (crewInfo.areaGuid) {
              let foundArea = vm.viewModel.areaList.find(a =>
                a.cmm_sys_cd === crewInfo.areaGuid ||
                a.cmm_sys_titl === crewInfo.areaGuid ||
                (crewInfo.areaGuid && a.cmm_sys_cd.indexOf(crewInfo.areaGuid) >= 0) ||
                (crewInfo.areaGuid && a.cmm_sys_titl.indexOf(crewInfo.areaGuid) >= 0)
              );
              if (foundArea) {
                vm.insertContentsModel.area = foundArea;
                console.log('권역 자동 설정:', foundArea.cmm_sys_titl);
              } else {
                // 권역을 찾지 못한 경우 직접 생성
                vm.insertContentsModel.area = {
                  cmm_sys_cd: crewInfo.areaGuid,
                  cmm_sys_titl: crewInfo.areaGuid
                };
                console.log('권역 직접 설정:', crewInfo.areaGuid);
              }
            }

            // 권역별 센터 목록 로드 후 센터 자동 선택
            if (vm.insertContentsModel.area && vm.insertContentsModel.area.cmm_sys_cd) {
              return vm.fnGetFacilityList().then(() => {
                console.log('센터 목록 로드 완료:', vm.insertContentsModel.facilityList.length, '개');

                // facUid로 센터 찾기
                let foundFacility = null;
                if (crewInfo.facUid) {
                  foundFacility = vm.insertContentsModel.facilityList.find(f => f.uid === crewInfo.facUid);
                }

                // facUid로 못찾으면 cntrName으로 찾기
                if (!foundFacility && crewInfo.cntrName) {
                  foundFacility = vm.insertContentsModel.facilityList.find(f =>
                    f.centerName === crewInfo.cntrName ||
                    (f.centerName && f.centerName.indexOf(crewInfo.cntrName) >= 0) ||
                    (crewInfo.cntrName && crewInfo.cntrName.indexOf(f.centerName) >= 0)
                  );
                }

                if (foundFacility) {
                  vm.insertContentsModel.facility = foundFacility;
                  vm.insertContentsModel.cntrName = foundFacility.centerName;
                  vm.isCrewInfoLoaded = true; // 크루원 정보 설정 완료
                  console.log('센터 자동 설정:', foundFacility.centerName);
                } else if (crewInfo.cntrName) {
                  // 센터를 찾지 못한 경우 직접 설정
                  vm.insertContentsModel.facility = {
                    uid: crewInfo.facUid || '',
                    centerName: crewInfo.cntrName
                  };
                  vm.insertContentsModel.cntrName = crewInfo.cntrName;
                  vm.isCrewInfoLoaded = true; // 크루원 정보 설정 완료
                  console.log('센터 직접 설정:', crewInfo.cntrName);
                }
                return response;
              }).finally(() => {
                // 센터 목록 로드 완료 후 플래그 해제
                vm.isLoadingCrewInfo = false;
              });
            } else if (crewInfo.cntrName) {
              // 권역이 없어도 센터명은 설정
              vm.insertContentsModel.cntrName = crewInfo.cntrName;
              console.log('권역 없이 센터명만 설정:', crewInfo.cntrName);
              vm.isLoadingCrewInfo = false; // 플래그 해제
            } else {
              vm.isLoadingCrewInfo = false; // 플래그 해제
            }
          } else {
            console.log('승인되지 않은 크루원 - 자동 설정 스킵 (상태:', crewInfo.arpv, ')');
            vm.isLoadingCrewInfo = false; // 플래그 해제
          }
        } else {
          console.log('크루원 정보 없음 - 신규 사용자');
          vm.isLoadingCrewInfo = false; // 플래그 해제
        }
        return response;
      }).catch(function (ex) {
        console.log('크루원 정보 조회 실패:', ex);
        vm.isLoadingCrewInfo = false; // 플래그 해제
        return Promise.resolve(); // 실패해도 진행
      });
    },
    fnOnSetListCode: function (brdCtg, _code) { // 코드 조회
      let vm = this;

      Axios.post("/api/expinfo/code", {searchCode: _code}).then(function (response) {
        vm.viewModel.affList = response.data.expinfoCodeList;

        // 뒤로가기 상태 복원 체크 (세션 스토리지에서)
        let listType = brdCtg === 'movie' ? 'movie' : 'contents';
        if (vm.checkAndRestoreCrewListState(listType)) {
          console.log('[Crew' + listType + '] state restored, skipping initial list fetch');
          return; // 복원 성공 시 리스트 조회 생략
        }

        let search = $("#search").val();
        if (search) {
          vm.searchStr = search.split("_");
          if (vm.searchStr[0]) {
            vm.viewModel.areaList.forEach((item) => {
              if (vm.searchStr[0] == item.cmm_sys_cd) {
                vm.viewYnModel.areaGuid = item;
              }
            });
          }

          vm.viewModel.affList.forEach(function (item) {
            if (vm.searchStr[1] == item.cmm_sys_cd) {
              vm.viewYnModel.affiliation = item;
            }
          });
        }

        vm.fnGetCrewList(brdCtg, 1);
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , fnGotoSearch(brdCtg) {
      let vm = this;
      let search = "";

      search = (vm.viewYnModel.areaGuid ? vm.viewYnModel.areaGuid.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "");

      location.href = "/customer/crew/"+ brdCtg +"?search=" + encodeURIComponent(search);
    }
    ,fnGotoDetailP(brdCtg, uid){
      let vm = this;
      let search = "";

      search = search + (vm.viewYnModel.trget ? vm.viewYnModel.trget.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "");

      // 상세 이동 전 목록 상태 저장 + 복원 플래그 세팅
      try {
        vm.saveActivityMapState(true);
        sessionStorage.setItem(ACT_MAP_BACK_INTENT_KEY, '1');
      } catch(e) { console.log('[ACT_MAP] set back intent error', e); }

      let url = brdCtg == 'movie' ? '/customer/crew/detailMovie?paramUid=' : '/customer/crew/detail?paramUid=';
      location.href = url + uid + "&search=" + encodeURIComponent(search);
    },
    fnGetFacilityList: function () { // 권역별 센터 목록 조회
      let vm = this;

      if (!vm.insertContentsModel.area || !vm.insertContentsModel.area.cmm_sys_cd) {
        vm.insertContentsModel.facilityList = [];
        vm.insertContentsModel.facility = {};
        vm.insertContentsModel.cntrName = '';
        return Promise.resolve();
      }

      // 권역명을 데이터베이스 코드로 매핑
      let areaCodeMap = {
        "동북권": "GU0002",
        "동남권": "GU0005",
        "서북권": "GU0003",
        "서남권": "GU0004"
      };

      let crewArUid = areaCodeMap[vm.insertContentsModel.area.cmm_sys_cd] || vm.insertContentsModel.area.cmm_sys_cd;

      let param = {
        crewArUid: crewArUid
      };

      return Axios.post("/customer/crew/facilitiesByArea", param).then(function (response) {
        vm.insertContentsModel.facilityList = response.data.facilityList || [];
        vm.insertContentsModel.facility = {};
        vm.insertContentsModel.cntrName = '';
        return response;
      }).catch(function (ex) {
        console.log("센터 목록 조회 오류:", ex);
        vm.insertContentsModel.facilityList = [];
        throw ex;
      });
    },
    fnSelectFacility: function (facility) { // 센터 선택
      let vm = this;
      vm.insertContentsModel.facility = facility;
      vm.insertContentsModel.cntrName = facility.centerName;
    },
    fnGetApplyFacilityList: function () { // 권한신청용 권역별 센터 목록 조회
      let vm = this;

      if (!vm.applyCrewModel.area || !vm.applyCrewModel.area.cmm_sys_cd) {
        vm.applyCrewModel.facilityList = [];
        vm.applyCrewModel.facility = {};
        vm.applyCrewModel.cntrName = '';
        return;
      }

      // 권역명을 데이터베이스 코드로 매핑
      let areaCodeMap = {
        "동북권": "GU0002",
        "동남권": "GU0005",
        "서북권": "GU0003",
        "서남권": "GU0004"
      };

      let crewArUid = areaCodeMap[vm.applyCrewModel.area.cmm_sys_cd] || vm.applyCrewModel.area.cmm_sys_cd;

      let param = {
        crewArUid: crewArUid
      };

      Axios.post("/customer/crew/facilitiesByArea", param).then(function (response) {
        vm.applyCrewModel.facilityList = response.data.facilityList || [];
        vm.applyCrewModel.facility = {};
        vm.applyCrewModel.cntrName = '';
      }).catch(function (ex) {
        console.log("센터 목록 조회 오류:", ex);
        vm.applyCrewModel.facilityList = [];
      });
    },
    fnSelectApplyFacility: function (facility) { // 권한신청용 센터 선택
      let vm = this;
      vm.applyCrewModel.facility = facility;
      vm.applyCrewModel.cntrName = facility.centerName;
    },
    fnGetCrewAiList: function (brdCtg) {
      let vm = this;
      let param = {};
      param.brdCtg = brdCtg;

      Axios.post("/customer/youthcrew/aiList", {youthCrewVO: param}).then(function (response) {
        let _list = response.data.youthCrewList;
        let _img = response.data.fileImgList;

        if (_list != null) {
          _list.forEach(function (item) {
            item.checked = false;

            if(item.filePath != null) {
              item.filePath = item.filePath.replaceAll('/var/uploadfiles', '');
            }
          });
        }
        if (_img != null) {
          _img.forEach(function (item, idx) {
            if (item != null) {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
              item.video = "/video/" + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.mp4';
            }
          });
        }

        vm.crewAiList = _list;
        vm.pageImgList = _img;
        vm.rm = Math.min(5, Math.ceil(_list.length/5));
        //console.log("challengeList",vm.viewModel);
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetCrewList: function (brdCtg, pageNumber) {
      let vm = this;
      vm.pageNo = pageNumber ? pageNumber : 1;

      let param = {};

      param.pageSize = 8;
      param.pageNo = vm.pageNo;
      param.brdCtg = brdCtg;
      param.areaGuid = vm.viewYnModel.areaGuid ? vm.viewYnModel.areaGuid.cmm_sys_cd : '';
      param.affCd =  vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : '';

      console.log(param);

      Axios.post("/customer/youthcrew/list", {youthCrewVO: param}).then(function (response) {
        let _list = response.data.youthCrewList;
        let _img = response.data.fileImgList;

        if (_list != null) {
          _list.forEach(function (item) {
            item.checked = false;

            if(item.filePath != null) {
              item.filePath = item.filePath.replaceAll('/var/uploadfiles', '');
            }
          });
        }
        if (_img != null) {
          _img.forEach(function (item, idx) {
            if (item != null) {
              item.img = '/video/' + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.' + item.file_ext;
              item.video = "/video/" + item.file_new_name.substring(0, 8) + "/" + item.file_new_name.split(".")[0] + '.mp4';
            }
          });
        }

        vm.viewModel.totalCount = response.data.totalCount;

        if (vm.pageNo == 1) {
          vm.crewListModel.list = _list;
          vm.crewListModel.imgList = _img;
        }
        else {
          vm.crewListModel.list = vm.crewListModel.list.concat(_list);
          vm.crewListModel.imgList = vm.crewListModel.imgList.concat(_img);
        }

        if(response.data.totalCount == vm.crewListModel.list.length) {
          vm.viewModel.showMore = false;
        } else {
          vm.viewModel.showMore = true;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGoMovieDetail: function (uidKey) {
      let vm = this;

      // 상세 이동 전 목록 상태 저장
      try {
        vm.saveCrewListState('movie');
        sessionStorage.setItem(CREW_MOVIE_BACK_INTENT_KEY, 'true');
      } catch(e) { console.log('[CrewMovie] failed to save state before detail:', e); }

      let search = (vm.viewYnModel.areaGuid ? vm.viewYnModel.areaGuid.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "");
      location.href = "/customer/crew/detailMovie?paramUid=" + uidKey + "&search=" + search;
    },
    fnGoContentsDetail: function (uidKey) {
      let vm = this;

      // 상세 이동 전 목록 상태 저장
      try {
        vm.saveCrewListState('contents');
        sessionStorage.setItem(CREW_CONTENTS_BACK_INTENT_KEY, 'true');
      } catch(e) { console.log('[CrewContents] failed to save state before detail:', e); }

      let search = (vm.viewYnModel.areaGuid ? vm.viewYnModel.areaGuid.cmm_sys_cd : "") + "_";
      search = search + (vm.viewYnModel.affiliation ? vm.viewYnModel.affiliation.cmm_sys_cd : "");

      location.href = "/customer/crew/detail?paramUid=" + uidKey + "&search=" + search;
    },
    fnGoContentsInsertMain: function (uid, brdCtg) { // 크루 컨텐츠 업로드/수정 페이지
      let vm = this;
      let url = '/customer/crew/contentsInsert';

      if (uid) {
        // 수정 모드
        url += '?paramUid=' + uid;
        if (brdCtg) {
          url += '&type=' + brdCtg;
        }
      } else {
        // 신규 작성 모드
        if (brdCtg) {
          url += '?type=' + brdCtg;
        }
      }

      location.href = url;
    },
    fnDelYouthCrew: function (uid, backCnt) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.uidKey = uid;


      swal({
        text: "삭제 하시겠습니까?\n되돌릴 수 없습니다.",
        // icon: vm.fnOnLoadSwalImageData("info"),
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true, visible: true},
          cancle: {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/customer/youthcrew/deleteContents", {youthCrewVO: param}).then(function (response) {
            swal("삭제되었습니다.").then(result => {
              if (backCnt == 0) {
                window.location.reload();
              } else if (backCnt == -1) {
                window.history.back();
              }
            });
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });
    },
    fnGoApplyPage()
    {
      let vm = this;
      let _userKey = $("#usrKey").val();

      if (_userKey == null || _userKey == "") {
        swal({
          text: "청소년홍보단 몽땅크루 권한신청은 로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true
            },
            cancle: {
              text: "취소",
              value: false
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
      } else {
        location.href = "/customer/crew/applyCrew";
      }
    }
    , fnSwalAlert(_text){
      swal({
        text : _text,
        // icon : this.fnOnLoadSwalImageData("error"),
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          }
          , cancle : {
            text : "취소",
            value : false,
            visible : false
          }
        }
      });
    }
    , fnSwalSuccess(_text, successFunction){
      let vm = this;

      swal({
        text : _text,
        closeOnClickOutside : false,
        // icon : vm.fnOnLoadSwalImageData("success"),
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : false
          }
        }
      }).then(result => {
        if(result){
          if(successFunction != null){
            successFunction();
          }
        }
      });
    },
    fnGoQNAPage()
    {
      var _userKey = $('#usrKey').val();
      if (_userKey == null || _userKey == "") {
        swal({
          text: "문의하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=/customer/notice/qna?qnaType=BRDNVYTHNV00413";
          }
        });
      } else {
        location.href = '/customer/notice/qna?qnaType=BRDNVYTHNV00413'
      }
    },
    doSubmitApply() {
      let vm = this;

      let _userKey = $("#usrKey").val();
      if (_userKey == null || _userKey == "") {
        swal({
          text: "청소년홍보단 몽땅크루 권한신청은 로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true
            },
            cancle: {
              text: "취소",
              value: false
            }
          }
        }).then((result) => {
          if (result) {
            location.href = "/youthnavi/signup/login";
          }
        });
      } else if ($("#usrSysCode").val() !== 'USRNVYTHNV00110') {
        return swal("청소년만 작성이 가능합니다.")
      } else {

        if (vm.applyCrewModel.area.length == 0) {
          swal("권역을 선택 해주세요.").then(function () {
            $('#area').focus();
          });
          return false;
        }

        if (vm.applyCrewModel.cntrName == null || vm.applyCrewModel.cntrName == "") {
          swal("소속 센터명을 입력해 주세요.").then(function () {
            $('#cntrName').focus();
          });
          return false;
        }

        let param = {
          userKey: _userKey,
          areaGuid: vm.applyCrewModel.area.cmm_sys_cd,
          facUid: vm.applyCrewModel.facility.uid,
          cntrName: vm.applyCrewModel.cntrName
        };

        Axios.post("/customer/youthcrew/isCrew", {youthCrewVO: param}).then(function (response) {
          let _result = response.data.result;

          if (_result == 0) {
            Axios.post("/customer/youthcrew/insertApply", {youthCrewVO: param}).then(function (response) {
              let result = response.data.result;

              if (result > 0) {
                swal({
                  text: "승인신청이 완료되었습니다.\n권역담당자 승인 신청완료후 활동가능합니다.",
                  closeOnClickOutside: false,
                  buttons: {
                    confirm: {text: "확인", value: true , visible: true}
                  }
                }).then(result => {
                  if (result) {
                    location.href = '/customer/crew/introduce';
                  }
                });
              } else {
                swal({
                  title: '신청 실패',
                  text: '청소년홍보단 몽땅크루 권한신청에 실패하였습니다.',
                  // icon : vm.fnOnLoadSwalImageData('error'),
                  buttons: {
                    cancel: {
                      text: "취소",
                      value: false,
                      visible: false
                    },
                    confirm: {
                      text: "확인",
                      value: true,
                      visible: true
                    },
                  },
                  dangerMode: false
                }).then(result => {
                  if (result) {
                    return false;
                  }
                });
              }
            }).catch(function (ex) {
              console.log(ex);
              vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
              return false;
            });
          } else {
            if (_result == 100) {
              return swal("이미 크루 신청이 완료되었습니다.\n크루 등록은 소속기관 담당자에게 요청 하세요.");
            } else if (_result == 200) {
              swal({
                text: "기존에 권한 신청했던 소속 기관이 있습니다.\n확인을 누르시면 현재 신청 기관으로 신청하게 됩니다.\n\n계속 하려면 확인을 눌러 주세요.",
                closeOnClickOutside: false,
                buttons: {
                  confirm: {
                    text: "신청",
                    value: true
                  },
                  cancle: {
                    text: "취소",
                    value: false
                  }
                }
              }).then((result) => {
                if (result) {
                  Axios.post("/customer/youthcrew/updateFacApply", {youthCrewVO: param}).then(function (response) {
                    let result = response.data.result;

                    if (result > 0) {
                      vm.fnSwalSuccess('크루 신청이 완료되었습니다.\n소속기관 담당자 확인 후 등록인 완료됩니다.', setTimeout(function () {
                        location.href = "/customer/crew/introduce";
                      }, 1000));
                    } else {
                      vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
                      return false;
                    }
                  }).catch(function (ex) {
                    vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
                    return false;
                  });
                }
              });
            } else if (_result == 1000) {
              return swal("이미 등록된 크루 입니다.");
            } else if (_result == 2000) {
              swal({
                text: "소속기관이 아닌 다른 기관을 선택했습니다.\n기존 소속 기관에서는 크루 권한이 사라집니다.\n\n계속 진행하시려면 “신청”을 눌러주세요.",
                closeOnClickOutside: false,
                buttons: {
                  confirm: {
                    text: "신청",
                    value: true
                  },
                  cancle: {
                    text: "취소",
                    value: false
                  }
                }
              }).then((result) => {
                if (result) {
                  Axios.post("/customer/youthcrew/reApply", {youthCrewVO: param}).then(function (response) {
                    let result = response.data.result;

                    if (result > 0) {
                      vm.fnSwalSuccess('크루 신청이 완료되었습니다.\n소속기관 담당자 확인 후 등록인 완료됩니다.', setTimeout(function () {
                        location.href = "/customer/crew/introduce";
                      }, 1000));
                    } else {
                      vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
                      return false;
                    }
                  }).catch(function (ex) {
                    vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
                    return false;
                  });
                }
              });
            }
          }
        }).catch(function (ex) {
          vm.fnSwalAlert('오류가 발생하였습니다.\n 잠시 후 다시 시도하여주세요.');
          console.log(ex);
        });
      }
    }
    , fnGetCrewStats: function ()
    {
      let vm = this;
      let param = {};

      Axios.post("/customer/youthcrew/myCrewStatus", {youthCrewVO: param}).then(function (response) {
        let _result = response.data.youthCrewVO;

        if (_result) {
          if (_result.arpv == 'approve')
          {
            vm.isCrew = true;
          }
          else if (_result.arpv == 'ready')
          {
            vm.isReady = true;
          }
          vm.loginArea = _result.areaGuid || '';
          vm.loginCntrName = _result.cntrName || '';
        }

      }).catch(function (ex) {
        console.log(ex);
      });
    }
    , insertApplyCrew: function () {
      let param = {
        userKey: _userKey,
        areaGuid: vm.applyCrewModel.area.cmm_sys_cd,
        facUid: vm.applyCrewModel.facility.uid,
        cntrName: vm.applyCrewModel.cntrName
      };

      Axios.post("/customer/youthcrew/insertApply", {youthCrewVO: param}).then(function (response) {
        let result = response.data.result;

        if (result > 0) {
          vm.fnSwalSuccess('신청이 완료되었습니다.', setTimeout(function () {
            location.href = "/customer/crew/introduce";
          }, 2500));

        } else if (result == -999) {
          swal({
            title: '신청 실패',
            text: '청소년홍보단 몽땅크루 권한신청에 실패하였습니다.',
            // icon : vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "취소",
                value: false,
                visible: false
              },
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
            },
            dangerMode: false
          }).then(result => {
            if (result) {
              return false;
            }
          });
        } else {
          vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
        vm.fnSwalAlert('오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.');
        return false;
      });
    },
    allReset: function (brdCtg)
    {
      let vm = this;
      vm.viewYnModel.areaGuid = null;
      vm.viewYnModel.affiliation = null;

      vm.fnGetCrewList(brdCtg, 1);
    },
    fnSetReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }
      swal({
        text : "댓글을 작성하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          let vm = this;
          let param = {};
          param.brdUidKey = $("#paramUid").val();
          param.usrKey = $("#usrKey").val();
          if (_depth == 0) {
            param.replyDepth = _depth;
            param.replyContent = vm.insertReplyModel.replyContent;
            if (!vm.insertReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          } else if (_depth == 1) {
            param.replyDepth = _depth;
            param.replyContent = vm.insertReReplyModel.replyContent;
            param.parentsUidKey = replyUidKey;
            if (!vm.insertReReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          }

          Axios.post("/customer/youthcrew/insertReply", {youthCrewReplyVO: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                buttons: {
                  cancel: {text: "취소", value: false, visible: false,},
                  confirm: {text: "확인", value: true, visible: true,},
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });

    },
    //커뮤니티 댓글 수정
    fnUptReply: function (_depth, replyUidKey) {
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text : "로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside : false,
          buttons : {
            confirm : {
              text : "확인",
              value : true,
              visible : true
            },
            cancel : {
              text : "취소",
              value : false,
              visible : true
            }
          }
        }).then(result => {
          if(result){
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      swal({
        text : "댓글을 수정하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          let vm = this;
          let param = {};
          param.usrKey = $("#usrKey").val();
          if (_depth == 0) {
            param.replyUidKey = replyUidKey;
            param.replyContent = vm.updateReplyModel.replyContent;
            if (!vm.updateReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          } else if (_depth == 1) {
            param.replyUidKey = replyUidKey;
            param.replyContent = vm.updateReReplyModel.replyContent;
            if (!vm.updateReReplyModel.replyContent) {
              swal("내용을 입력해주세요.");
              return false;
            }
          }

          Axios.post("/customer/youthcrew/updateReply", {youthCrewReplyVO: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                // icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {text: "취소", value: false, visible: false,},
                  confirm: {text: "확인", value: true, visible: true,},
                },
                dangerMode: false
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });


    },
    //커뮤니티 댓글 삭제
    fnDelReply: function (replyUidKey) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.replyUidKey = replyUidKey;

      swal({
        text : "댓글을 삭제하시겠습니까?",
        closeOnClickOutside : false,
        buttons : {
          confirm : {
            text : "확인",
            value : true,
            visible : true
          },
          cancel : {
            text : "취소",
            value : false,
            visible : true
          }
        }
      }).then(result => {
        if(result){
          Axios.post("/customer/youthcrew/deleteReply", {youthCrewReplyVO: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              window.location.reload();
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      });
    },

    //댓글작성 레이아웃 출력
    fnShowReplyWrite: function () {
      let vm = this;
      vm.viewModel.isReply = true;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //대댓글 작성 레이아웃 출력
    fnShowReReplyWrite: function (key) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = true;
      vm.viewModel.isReReplyUpt = false;
      vm.viewModel.currReplyUidKey = key;

      console.log(vm.viewModel);
      console.log(key);
    },
    //댓글 수정 값 세팅
    fnReplySetValue: function (vo) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
      vm.fpt = ''
      if (vo.replyDepth == 0) {
        vm.viewModel.isReplyUpt = true;
        vm.updateReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReplyModel.replyContent = vo.replyContent;
      } else if (vo.replyDepth == 1) {
        vm.viewModel.isReReplyUpt = true;
        vm.updateReReplyModel.replyUidKey = vo.replyUidKey;
        vm.updateReReplyModel.replyContent = vo.replyContent;
      }
    },
    fnGetReportCodeList: function () {
      let vm = this;
      Axios.post("/customer/youthcrew/selectReportCodeList", {youthCrewVO: {}}).then(function (response) {
        vm.viewModel.reportCodeList = response.data.list || [];
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnGetReportList: function () {
      let vm = this;
      let usrKey = $("#usrKey").val();
      if (!usrKey) {
        vm.viewModel.reportList = [];
        vm.viewModel.isLike = false;
        return;
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = usrKey;

      Axios.post("/customer/youthcrew/selectReportList", {youthCrewVO: param}).then(function (response) {
        vm.viewModel.reportList = response.data.list || [];

        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100" && report.likeYn == "Y") { //좋아요
              vm.viewModel.isLike = true;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOpenReport: function (kind) {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        if (kind == 'report') {
          swal({
            text: "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
            closeOnClickOutside: false,
            buttons: {
              confirm: {
                text: "확인",
                value: true,
                visible: true
              },
              cancel: {
                text: "취소",
                value: false,
                visible: true
              }
            }
          }).then(result => {
            if (result) {
              location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
            }
          });

        }
        return false;
      }

      if (kind == 'report') {
        if (vm.viewModel.detail && vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신이 올린 글은 신고할 수 없습니다.");
          return false;
        }

        let reportFlag = false;
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
              reportFlag = true;
            }
          });
        }
        if (reportFlag) {
          swal("접수된 신고 이력이 있습니다.");
          return false;
        }

        vm.insertReport.reportValue = '';
        vm.insertReport.reportEtcValue = '';
        vm.viewModel.isReport = true;
      }
    },
    fnShowReportWrite: function () {
      this.viewModel.isReport = false;
      this.insertReport.reportValue = '';
      this.insertReport.reportEtcValue = '';
    },
    fnSetReport1: function () {
      this.fnSetReport('report');
    },
    fnSetReport: function (kind) {
      let vm = this;
      let url = "/customer/youthcrew/insertRecommend";

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal({
          text: "신고하기는 로그인한 회원만 가능합니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: "확인",
              value: true,
              visible: true
            },
            cancel: {
              text: "취소",
              value: false,
              visible: true
            }
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (kind == 'report') {
        let reportFlag = false;
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
              reportFlag = true;
            }
          });
        }

        if (reportFlag) {
          swal("접수된 신고 이력이 있습니다.");
          return false;
        } else {
          if (!vm.insertReport.reportValue) {
            swal("신고사유를 선택해주세요.");
            return false;
          } else if (vm.insertReport.reportValue == 'RPTNVYTHNV00400' && vm.insertReport.reportEtcValue.trim().length == 0) {
            swal("기타사유를 입력해 주세요");
            return false;
          }
        }
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      if (kind == 'report') {
        param.rcmmCate = "RCMNVYTHNV00200"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.reportValue = vm.insertReport.reportValue;
        if (vm.insertReport.reportValue == "RPTNVYTHNV00400") {
          param.reportEtcValue = vm.insertReport.reportEtcValue;
        }
      }

      Axios.post(url, {youthCrewVO: param}).then(function (response) {
        if (kind == 'report') {
          if (response.data.succCnt > 0) {
            swal("등록되었습니다.").then(result => {
              location.reload();
            });
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },

    fnSetReportLike: function () {
      let vm = this;
      let url = "/customer/youthcrew/insertRecommend";

      if ($("#usrKey").val() == null || $("#usrKey").val() == "" || $("#usrKey").val() == "GUEST") {
        swal({
          text: "좋아요는 로그인이 필요한 기능입니다.\n로그인하시겠습니까?",
          closeOnClickOutside: false,
          buttons: {
            confirm: {text: "확인", value: true , visible: true},
            cancel:  {text: "취소", value: false, visible: true}
          }
        }).then(result => {
          if (result) {
            location.href = "/youthnavi/signup/login?returnURI=" + encodeURIComponent(window.location.pathname + window.location.search);
          }
        });
        return false;
      }

      if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
        swal("자신이 올린 글은 좋아요를 누를 수 없습니다.");
        vm.viewModel.isLike = false;
        return false;
      }

      if (vm.viewModel.reportList.length > 0) {
        vm.viewModel.reportList.forEach(function (report) {
          if (report.rcmmCate == "RCMNVYTHNV00100") { //좋아요
            url = "/customer/youthcrew/updateYouthLike";
          }
        });
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      param.rcmmCate = "RCMNVYTHNV00100";
      param.likeYn = 'Y';

      Axios.post(url, {youthCrewVO: param}).then(function (response) {
        vm.viewModel.isLike = !vm.viewModel.isLike;

        // 좋아요 카운트 업데이트
        if (vm.viewModel.isLike) {
          vm.viewModel.detail.likeCnt = (vm.viewModel.detail.likeCnt || 0) + 1;
        } else {
          vm.viewModel.detail.likeCnt = Math.max((vm.viewModel.detail.likeCnt || 0) - 1, 0);
        }

        if (vm.viewModel.reportList.length <= 2) { //신고+추천
          vm.viewModel.reportList.push(param);
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    fnOnClickCrewExit: function(){
      let vm = this;

      let param = {
        usrKey : $("#usrKey").val(),
        usrId : $("#usrId").val()
      };

      swal({
        text: "확인을 누르면 크루 권한이 포기됩니다.\n작성한 콘텐츠는 유지됩니다.\n\n크루를 탈퇴하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true , visible: true},
          cancel:  {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/api/youthcrew/approve/mycrewreturn", { youthCrewVO: param }).then(function(response) {
            let result = response.data.resultCount;
            if(result > 0){
              swal({
                text: "크루 탈퇴가 완료되었습니다.\n다시 권한 신청을 하시면 크루 활동이 가능합니다.",
                closeOnClickOutside: false,
                buttons: {
                  confirm: {text: "확인", value: true , visible: true}
                }
              }).then(result => {
                if (result) {
                  location.href = '/customer/crew/introduce';
                }
              });
            } else {
              swal("크루 탈퇴에 실패하였습니다.\n잠시 후 다시 시도해주세요.");
            }
          }).catch(function(ex) {
            console.log(ex);
            swal("오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.");
          });
        }
      });
    },
    fnOnClickCrewChange: function(){
      let vm = this;

      let param = {
        usrKey : $("#usrKey").val(),
        usrId : $("#usrId").val()
      };

      swal({
        text: "현재 " + vm.loginArea + " 크루 입니다.\n확인을 누르면 몽땅크루 권한이 취소되고\n권한신청을 다시 해야 합니다.\n\n권한신청을 취소하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true , visible: true},
          cancel:  {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/api/youthcrew/approve/mycrewreturn", { youthCrewVO: param }).then(function(response) {
            let result = response.data.resultCount;
            if(result > 0){
              swal({
                text: "권한이 취소되었습니다.\n권역과 소속기관을 다시 선택 후\n신청 버튼을 누르세요.",
                closeOnClickOutside: false,
                buttons: {
                  confirm: {text: "확인", value: true , visible: true}
                }
              }).then(result => {
                if (result) {
                  // 폼 활성화 및 초기화
                  vm.isCrewChangeMode = true;
                  vm.applyCrewModel.area = '';
                  vm.applyCrewModel.facility = {};
                  vm.applyCrewModel.cntrName = '';
                  vm.applyCrewModel.facilityList = [];
                }
              });
            } else {
              swal("권한 취소에 실패하였습니다.\n잠시 후 다시 시도해주세요.");
            }
          }).catch(function(ex) {
            console.log(ex);
            swal("오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.");
          });
        }
      });
    }
    ,
    fnOnClickCrewCancel: function(){
      let vm = this;

      let param = {
        usrKey : $("#usrKey").val(),
        usrId : $("#usrId").val(),
        rnum : 0,
        arpv: 'ready'
      };

      swal({
        text: "확인을 누르면 권한 신청이 취소 됩니다.\n\n권한신청을 취소하시겠습니까?",
        closeOnClickOutside: false,
        buttons: {
          confirm: {text: "확인", value: true , visible: true},
          cancel:  {text: "취소", value: false, visible: true}
        }
      }).then(result => {
        if (result) {
          Axios.post("/api/youthcrew/approve/mycrewcancel", { youthCrewVO: param }).then(function(response) {
            let result = response.data.resultCount;
            if(result > 0){
              swal({
                text: "권한이 취소되었습니다.\n다시 권한 신청을 할 수 있습니다.",
                closeOnClickOutside: false,
                buttons: {
                  confirm: {text: "확인", value: true , visible: true}
                }
              }).then(result => {
                if (result) {
                  location.href = '/customer/crew/introduce';
                }
              });
            }
          }).catch(function(ex) {
            console.log(ex);
          });
        }
      });
    },
    getShareUrl: function () {
      let uidKey = $("#paramUid").val();
      let path = window.location.pathname.indexOf('detailMovie') > -1 ? '/customer/crew/detailMovie' : '/customer/crew/detail';
      return path + '?paramUid=' + uidKey + '&shared=Y';
    },
    fnOnClickKakaoShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      Axios.post("/api/url/address", {}).then(function (response) {
        let urlAddress = response.data.urlName;
        _uri = urlAddress + vm.getShareUrl();

        vm.fnShareLog($("#paramUid").val());

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          vm.viewModel.detail.title || '',
          _imgPath,
          '',
          '',
          '',
          '',
          ''
        );
      });
    },
    fnOnClickNaverShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      Axios.post("/api/url/address", {}).then(function (response) {
        let urlAddress = response.data.urlName;
        _uri = urlAddress + vm.getShareUrl();

        vm.fnShareLog($("#paramUid").val());

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          vm.viewModel.detail.title || '',
          _imgPath
        );
      });
    },
    fnOnClickFacebookShare: function () {
      let vm = this;
      Axios.post("/api/url/address", {}).then(function (response) {
        let urlAddress = response.data.urlName;
        let _uri = urlAddress + vm.getShareUrl();

        vm.fnShareLog($("#paramUid").val());

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    },
    fnOnClickLinkShare: function () {
      let vm = this;
      Axios.post("/api/url/address", {}).then(function (response) {
        let urlAddress = response.data.urlName;
        let _uri = urlAddress + vm.getShareUrl();

        vm.fnShareLog($("#paramUid").val());

        let popup_url = '/customer/activity/share/link';
        popup_url += '?url=' + encodeURIComponent(_uri);
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          sessionStorage.setItem("POP_CLOSE_URL", location.href);
          location.href = popup_url;
        } else {
          window.open(popup_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
        }
      });
    },
    fnShareLog: function (uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    },


    //에디터 사용
    onEditorChange: function (event) {
      let vm = this;

      vm.insertContentsModel.contents = event.html;
      this.$emit("getEditorInfo", event);
    },

    // 크루 목록 상태 저장 (contents/movie)
    saveCrewListState: function (type) {
      const vm = this;
      const stateKey = type === 'movie' ? CREW_MOVIE_STATE_KEY : CREW_CONTENTS_STATE_KEY;
      const state = {
        crewList: vm.crewListModel.list,
        imgList: vm.crewListModel.imgList,
        pageNo: vm.pageNo,
        totalCount: vm.viewModel.totalCount,
        showMore: vm.viewModel.showMore,
        areaGuid: vm.viewYnModel.areaGuid,
        affiliation: vm.viewYnModel.affiliation,
        timestamp: Date.now()
      };
      try {
        sessionStorage.setItem(stateKey, JSON.stringify(state));
        console.log('[Crew' + type + '] state saved');
      } catch (e) {
        console.error('[Crew' + type + '] failed to save state:', e);
      }
    },

    // 크루 목록 상태 복원 (contents/movie)
    restoreCrewListState: function (type) {
      const vm = this;
      const stateKey = type === 'movie' ? CREW_MOVIE_STATE_KEY : CREW_CONTENTS_STATE_KEY;
      const intentKey = type === 'movie' ? CREW_MOVIE_BACK_INTENT_KEY : CREW_CONTENTS_BACK_INTENT_KEY;

      try {
        const raw = sessionStorage.getItem(stateKey);
        if (!raw) return false;

        const state = JSON.parse(raw);

        // TTL 체크
        if (Date.now() - state.timestamp > CREW_STATE_TTL) {
          sessionStorage.removeItem(stateKey);
          sessionStorage.removeItem(intentKey);
          return false;
        }

        // 상태 복원
        vm.crewListModel.list = state.crewList || [];
        vm.crewListModel.imgList = state.imgList || [];
        vm.pageNo = state.pageNo || 1;
        vm.viewModel.totalCount = state.totalCount || 0;
        vm.viewModel.showMore = state.showMore !== undefined ? state.showMore : true;
        vm.viewYnModel.areaGuid = state.areaGuid || null;
        vm.viewYnModel.affiliation = state.affiliation || null;

        // 백 인텐트만 제거 (상태는 유지)
        sessionStorage.removeItem(intentKey);

        console.log('[Crew' + type + '] state restored from session storage');
        return true;
      } catch (e) {
        console.error('[Crew' + type + '] failed to restore state:', e);
        sessionStorage.removeItem(stateKey);
        sessionStorage.removeItem(intentKey);
        return false;
      }
    },

    // 뒤로가기로 목록 페이지 진입 시 상태 복원 체크
    checkAndRestoreCrewListState: function (type) {
      const vm = this;
      const intentKey = type === 'movie' ? CREW_MOVIE_BACK_INTENT_KEY : CREW_CONTENTS_BACK_INTENT_KEY;
      const detailPath = type === 'movie' ? '/customer/crew/detailMovie' : '/customer/crew/detail';

      const nav = performance.getEntriesByType('navigation')[0];
      const isBack = nav && (nav.type === 'back_forward');
      const ref = document.referrer || '';
      const fromDetailPage = ref.indexOf(detailPath) >= 0;
      const hasBackIntent = sessionStorage.getItem(intentKey) === 'true';

      if ((isBack || fromDetailPage) && hasBackIntent) {
        return vm.restoreCrewListState(type);
      }
      return false;
    }
  }
});
